// extracted by extract-css-chunks-webpack-plugin
module.exports = {"heading":"ui__heading__AHMAn","subHeading":"ui__subHeading__2nR8o","proTipBox":"ui__proTipBox__3oC-H"};